import { Admin } from "./admin";
import * as firebase from "firebase";

export class User {
  admin: Admin;
  birthday: string; //MM/DD/YYYY
  created_at?: firebase.firestore.Timestamp;
  credits: number;
  customer_id: string;
  email: string;
  id?: string;
  last_logged_in?: firebase.firestore.Timestamp;
  name: string;
  phone_number: string;
  profile_picture: string;
  referred_by: string;
  referral_code: string;
  constructor(data, id) {
    this.admin = new Admin(data["admin"]);
    this.birthday = data["birthday"];
    this.created_at = data["created_at"];
    this.credits = data["credits"];
    this.customer_id = data["customer_id"];
    this.email = data["email"];
    this.last_logged_in = data["last_logged_in"]
      ? data["last_logged_in"]
      : firebase.firestore.Timestamp.fromDate(new Date("01/01/2020"));
    this.id = id;
    this.name = data["name"];
    this.phone_number = data["phone_number"];
    this.profile_picture = data["profile_picture"];
    this.referral_code = data["referral_code"];
    this.referred_by = data["referred_by"];
  }

  get canEdit(): boolean {
    return (
      this.admin.type == "LineLeapAdmin" || this.admin.type == "VenueAdmin"
    );
  }

  get countCities(): number {
    return this.admin.type == "LineLeapAdmin"
      ? 999
      : this.admin.cities == null
      ? 0
      : this.admin.cities.length;
  }

  get countVenues(): number {
    return this.admin.type == "LineLeapAdmin"
      ? 999
      : this.admin.venues == null
      ? 0
      : this.admin.venues.length;
  }

  toJSON() {
    return {
      admin: this.admin.toJSON(),
      birthday: this.birthday,
      created_at: this.created_at,
      credits: this.credits,
      email: this.email,
      last_logged_in: this.last_logged_in,
      name: this.name,
      phone_number: this.phone_number,
      profile_picture: this.profile_picture,
      referral_code: this.referral_code,
      referred_by: this.referred_by
    };
  }

  // toFirebase() {
  //   return {
  //     birthday: "",
  //     created_at: this.created_at,
  //     credits: 0,
  //     customer_id: this.customer_id,
  //     email: this.email,
  //     name: this.name,
  //     phone_number: this.phone_number,
  //     referred_by: "",
  //     referral_code: ""
  //   };
  // }
}
